const RequiredAsterisk = () => (
  <span className="text-red-500" aria-hidden="true">
    *
  </span>
);

export default RequiredAsterisk;
